




















import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      avater: require('assets/img/common/halo-avater.png'),
      qrcodeUrl: require('assets/img/common/halo-qrcode.png'),
    };
  },
});
